// src/services/couponService.js
// *******************************************************************************
// Coupon validation + redemption — called by the quotation checkout (CheckoutStep3)
// and (validate) anywhere a code is applied. Mirrors receivableService import shape.
// *******************************************************************************
import axiosService from 'services/axiosService';
import { API } from 'constants/Api';

// Validate a coupon code against a base value (MG-C). Returns the body verbatim:
// { valid:true, couponId, discountType, discount, discountValue, netValue } | { valid:false, rejectionReason }
const validate = async ({ code, planId, operatorId, baseValue }) => {
  if (!code || baseValue == null) return { valid: false, rejectionReason: 'invalid_code' };
  try {
    const [result] = await axiosService.post({
      url: API.COUPONS.VALIDATE,
      data: { code, planId, operatorId, baseValue },
    });
    return result || { valid: false, rejectionReason: 'invalid_code' };
  } catch {
    return { valid: false, rejectionReason: 'invalid_code' };
  }
};

// Redeem a coupon for an order (fire-and-forget — never blocks order success).
const consume = async (couponId, { orderId, discountValue }) => {
  if (!couponId) return null;
  try {
    const url = API.COUPONS.CONSUME.replace(':_id', couponId);
    const [result] = await axiosService.put({ url, data: { orderId, discountValue } });
    return result;
  } catch {
    return null;
  }
};

const couponService = { validate, consume };
export default couponService;
